import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { CheckCircle2, Clock } from "lucide-react";
import { api, inr, fmtDate, useSEO } from "../../lib/api";

export default function OrderSuccess() {
  const { id } = useParams();
  const [o, setO] = useState(null);
  useSEO({ title: "Order placed" });
  useEffect(() => {
    let n = 0;
    const load = () => api.get(`/orders/${id}/summary`).then((r) => {
      setO(r.data);
      if (r.data.payment_method === "razorpay" && r.data.payment_status === "pending" && n++ < 5) setTimeout(load, 3000);
    }).catch(() => setO(false));
    load();
  }, [id]);
  if (o === false) return <div className="container-x py-24">Order not found.</div>;
  if (!o) return <div className="container-x py-24">Loading…</div>;
  const paid = o.payment_status === "paid" || o.payment_method === "cod";
  return (
    <div className="container-x py-16 max-w-2xl" data-testid="order-success-page">
      {paid ? <CheckCircle2 className="w-12 h-12 text-[#6B8E78]" /> : <Clock className="w-12 h-12 text-[#C69C5C]" />}
      <h1 className="text-4xl sm:text-5xl text-[#1B3B2B] mt-4">{paid ? "Thank you for your order" : "Order saved — payment pending"}</h1>
      <p className="text-stone-600 mt-3">Order number <b data-testid="order-number">{o.order_number}</b> · {fmtDate(o.created_at, true)}</p>
      <p className="text-sm text-stone-500 mt-1">Payment: <span data-testid="order-payment-status">{o.payment_method === "cod" ? "Cash on Delivery" : o.payment_status}</span> · Status: {o.status}</p>
      <div className="border border-[#E8E0D5] rounded-2xl p-5 mt-8 bg-[#FFFDF9] space-y-2 text-sm">
        {o.items.map((i) => <div key={i.product_id + (i.variant_id || "")} className="flex justify-between"><span>{i.name} × {i.qty}</span><span>{inr(i.line_total)}</span></div>)}
        <div className="border-t border-[#E8E0D5] pt-2 space-y-1">
          {o.coupon_discount > 0 && <div className="flex justify-between text-[#B91C1C]"><span>Coupon {o.coupon_code}</span><span>− {inr(o.coupon_discount)}</span></div>}
          <div className="flex justify-between"><span>Shipping</span><span>{o.shipping ? inr(o.shipping) : "Free"}</span></div>
          <div className="flex justify-between font-semibold text-[#1B3B2B]"><span>Total</span><span data-testid="order-total">{inr(o.total)}</span></div>
        </div>
      </div>
      <div className="flex gap-3 mt-8"><Link to="/track-order" className="rounded-full bg-[#1B3B2B] text-white px-6 py-3 text-sm" data-testid="order-track-link">Track order</Link><Link to="/shop" className="rounded-full border border-[#1B3B2B] px-6 py-3 text-sm">Continue shopping</Link></div>
    </div>
  );
}
